import { z } from '@harvestiq/zod';
import { SmsTemplateNames } from './sms-template-names';
import { lrpQuoteSchema } from '@harvestiq/usda-common';

export const smsTemplateDataSchema = z.discriminatedUnion('templateName', [
  z.object({
    templateName: z.literal(SmsTemplateNames.smsLrpQuote),
    data: z.object({
      quotes: lrpQuoteSchema.array(),
      campaignId: z.string().uuid(),
    }),
  }),
  z.object({
    templateName: z.literal(SmsTemplateNames.smsCustom),
    data: z.object({
      message: z.string(),
      recipientIds: z.string().array(),
    }),
  }),
  z.object({
    templateName: z.literal(SmsTemplateNames.smsSubscribe),
    data: z.object({
      phoneNumber: z.string(),
    }),
  }),
  z.object({
    templateName: z.literal(SmsTemplateNames.smsUnsubscribe),
    data: z.object({
      phoneNumber: z.string(),
    }),
  }),
  z.object({
    templateName: z.literal(SmsTemplateNames.smsOptInConfirmation),
    data: z.object({
      phoneNumber: z.string(),
    }),
  }),
]);
export type SmsTemplateData = z.infer<typeof smsTemplateDataSchema>;
